<template>
    <div class="month_nav_wrap">
        <div class="month_nav">
            <button class="btn_white" @click="action_BeforeMonth"><v-icon>mdi-chevron-left</v-icon></button>
            <span class="month">{{ dateString }}</span>
            <button class="btn_white" @click="action_NextMonth"><v-icon>mdi-chevron-right</v-icon></button>
            <button class="btn btn_s btn_white" @click="action_Today">{{ $t('work_schedule.top.label_today') }}</button>
            <div class="mgl_auto">
                <button class="btn_s btn_blue" v-if="isEditMode" @click="action_Save"><v-icon>mdi-check-circle-outline</v-icon> {{ $t('common.save') }}</button>
                <button class="btn_s btn_blue_line" v-if="!isEditMode" @click="action_ChangeMode"><v-icon>mdi-pencil</v-icon> {{ $t('work_schedule.top.label_edit_mode') }}</button>
            </div>
        </div>
    </div>
</template>


<script>
import { workerState, setSelectedDate, setModifyMode } from '../../../worker-state'

import moment from '@/util/MPMoment'

export default {
    data() {
        return {
            worker: workerState,
        }
    },
    computed: {
        selectedDate: function() { return this.worker.selectedDate },
        dateString: function() { return this.selectedDate.format(this.$t('work_schedule.date_format')) },
        isEditMode: function() { return this.worker.isModifyMode },
    },
    mounted() {
        setSelectedDate(moment().startOf('month'))
    },
    methods: {
        async action_BeforeMonth() {
            let result = await this.AlertController.runCheckLogics()
            console.log(result)
            if (result == false) { return }
            let date = moment(this.selectedDate).add(-1, 'month').startOf('month')
            setSelectedDate(date)
        },
        async action_NextMonth() {
            let result = await this.AlertController.runCheckLogics()
            if (result == false) { return }
            let date = moment(this.selectedDate).add(1, 'month').startOf('month')
            setSelectedDate(date)
        },
        async action_Today() {
            let result = await this.AlertController.runCheckLogics()
            if (result == false) { return }
            let date = moment().startOf('month')
            setSelectedDate(date)
        },
        action_ChangeMode() {
            setModifyMode(!this.worker.isModifyMode)
        },
        async action_Save() {
            await this.worker.updateBatch()
            setModifyMode(!this.worker.isModifyMode)
        }
    }
}
</script>